import { communicationsApi } from '@app/services'

import { FetchConversationParticipantLabelsResponse } from './types'

export const fetchConversationParticipantLabels = async (
  conversationId: number,
  signal?: AbortSignal
) => {
  const { data } =
    await communicationsApi.get<FetchConversationParticipantLabelsResponse>(
      `conversation/${conversationId}/participantLabels`,
      {
        signal,
      }
    )

  return data.participant
}
